import React, { useState } from "react";
import TextInput from "../../../../components/TextInput";
import { toast } from "../../../../components/toastNotification";
import ConfirmBoxModal from "../../../../components/ConfirmBoxModal";

import useAddOfficeOrigin from "./hooks/useAddOfficeOrigin";
import useOfficeOrigin from "./hooks/useOfficeOrigin";
import { useRecoilState } from "recoil";
import MaterialExTable from "../../../../components/tables/MaterialExTable";

import { addStateOfficeOrigin, setFilterTextOfficeOrigin } from "./atoms/atoms";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import SaveButton from "../../../../components/SaveButton";
import CancelButton from "../../../../components/CancelButton";
import { useQueryClient } from "react-query";

const OfficeOriginForm = () => {
  //Hooks
  const { mutateAsync: AddOfficeOrigin } = useAddOfficeOrigin();
  const { data } = useOfficeOrigin();
  //Recoils Call
  const [actionAddState, setActionAddState] =
    useRecoilState(addStateOfficeOrigin);
  const [filterText, setFilterText] = useRecoilState(setFilterTextOfficeOrigin);
  const [changed, setChanged] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [hasOfficeOrigin, setHasOfficeOrigin] = useState(false);
  const queryClient = useQueryClient();

  const defaulValues = {
    officeOriginId: 0,
    officeOriginName: "",
    createdBy: "",
    createdOn: null,
    isActive: 0,
  };
  const [officeOriginNewData, setOfficeOriginNewData] = useState([
    defaulValues,
  ]);
  const [officeOriginExist, setofficeOriginExist] = useState(false);

  const handleAddOfficeOrigin = (SourceType, fieldName, inputvalue) => {
    setChanged(true);
    setofficeOriginExist(false);
    inputvalue = inputvalue.trim();
    if (SourceType === "addOfficeOrigin") {
      if (fieldName === "officeOriginName") {
        const result = data.filter(
          (item) =>
            item.officeOriginName.toUpperCase() === inputvalue.toUpperCase()
        )[0];
        officeOriginNewData.map((x) => (x.officeOriginName = inputvalue));
        inputvalue === ""
          ? setHasOfficeOrigin(false)
          : setHasOfficeOrigin(true);
      }
    }
  };

  //save changes
  const handleSave = (officeOriginNewData) => {
    setOpenModal(false);
    if (actionAddState) {
      AddOfficeOrigin(officeOriginNewData, {
        onSuccess: (res) => {
          if (res === "Duplicate") {
            toast.fire("Failed", "The data already exists!", "error");
            setOpenModal(false);
          } else {
            setActionAddState(false);
            setOfficeOriginNewData([defaulValues]);
            queryClient.invalidateQueries(["GetOfficeOrigin"]);
            toast.fire(
              "Success",
              "Office Origin Added Successfully",
              "success"
            );
            setOpenModal(false);
          }
        },
        onError: () => {
          toast.fire("Failed", "Failed to Add Office Origin!", "error");
          queryClient.invalidateQueries(["GetOfficeOrigin"]);
        },
      });
    }
  };
  // end of saving changes

  const matcolumns = [
    {
      title: "Office Origin Name",
      field: "officeOriginName",
      render: (rowData) => {
        return (
          <div className="grid-cols-3 grid ">
            <div className="">
              <TextInput
                defaultValue={rowData.officeOriginName}
                onChange={(e) =>
                  handleAddOfficeOrigin(
                    "addOfficeOrigin",
                    "officeOriginName",
                    e.target.value
                  )
                }
              />
            </div>
          </div>
        );
      },
    },
  ];
  return (
    <div className="animate-fade-in-down">
      <div className="w-full ">
        <ConfirmBoxModal
          ModalTitle="Add Office Origin"
          qConfirmation=" Are you sure you want to add this?"
          isOpen={openModal}
          onClose={() => setOpenModal(false)}
          onClickFunction={() => {
            handleSave(officeOriginNewData);
          }}
        />
        <div className="p-3  space-y-1 border-l-2  border-primary box-shadow">
          <div className="flex items-center justify-between">
            <div className="text-base text-primary font-bold">
              Add New Office Origin
            </div>
            <div className="flex items-center space-x-2 pt-2 pb-2">
              <SaveButton
                className={`flex items-left shadow-md text-xs font-semibold text-white justify-left gap-x-1 rounded-full bg-senary hover:bg-senary px-3 py-1 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-senary focus:ring-opacity-70
              ${!hasOfficeOrigin ? "opacity-50" : "opactiy-100"}`}
                disabled={!hasOfficeOrigin}
                onClick={() => setOpenModal(true)}
              />
              <CancelButton
                className="flex items-left text-xs shadow-md font-semibold text-white justify-left gap-x-1 rounded-full bg-octonary hover:bg-octonary px-2 py-1 "
                onClick={() => {
                  setActionAddState(!actionAddState);
                  setFilterText("");
                }}
              />
            </div>
          </div>

          <div className="mt-2 h-0.5 w-full border-b-2 border-secondary mb-5"></div>

          <div className="py-1"></div>

          <div className="space-y-5 space-x-2 space-y-20 w-full  ">
            <MaterialExTable
              columns={matcolumns}
              data={officeOriginNewData}
              paging={false}
            />
          </div>
        </div>
        <div className="hidden sm:block" aria-hidden="true">
          <div className="pb-1.5"></div>
        </div>
      </div>
    </div>
  );
};

export default OfficeOriginForm;
